import React, { FC, memo } from 'react';
import { DivInnerFields, DivTitle } from '../../../styles';
import { Field } from 'formik';
import {
  COLORGATE_CONFIGURATION_TITLES,
  ColorgateConfigurationFields,
  RADIO_OPTIONS,
  RadioValues
} from '../../../constants';
import DropdownField from '../../FormComponents/DropdownFiled';
import { TColorgateConfigurationOptions } from '../../../types';
import NumberFormatField from '../../FormComponents/NumberFormatField';
import DefaultSizeField from '../../FormComponents/DefaultSizeField';
import ProportionalField from '../../FormComponents/ProportionalField';
import clsx from 'clsx';
import FnDropdown from '../../../../../components/elements/FnDropdown';

type TProps = {
  options: TColorgateConfigurationOptions;
  values: any;
};

const SizeRotationPositionBlock: FC<TProps> = ({ options, values }) => {
  return (
    <>
      <DivTitle>Size, rotation and position options</DivTitle>
      <Field name={ColorgateConfigurationFields.DefaultSize}>
        {({ field, form }) => (
          <DefaultSizeField
            name={field.name}
            options={RADIO_OPTIONS}
            title={COLORGATE_CONFIGURATION_TITLES.defaultSize}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <Field name={ColorgateConfigurationFields.ProportionalSize}>
        {({ field, form }) => (
          <ProportionalField
            name={field.name}
            options={RADIO_OPTIONS}
            title={COLORGATE_CONFIGURATION_TITLES.proportionalSize}
            value={field.value}
            defaultSizeFieldValue={form.values[ColorgateConfigurationFields.DefaultSize]}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <DivInnerFields
        className={clsx({
          ['hidden']: values[ColorgateConfigurationFields.ProportionalSize] === RadioValues.No
        })}
      >
        <FnDropdown
          propertyValue="value"
          propertyLabel="name"
          value={null}
          placeholder="Fit single copy to page (reduce only)"
          title="Fit type"
          options={[]}
          onChange={() => null}
          disabled={true}
        />
        <Field name={ColorgateConfigurationFields.ProportionalHeight}>
          {({ field, form }) => (
            <NumberFormatField
              name={field.name}
              title={COLORGATE_CONFIGURATION_TITLES.proportionalHeight}
              placeholder="Enter number"
              suffix="cm"
              decimalScale={1}
              value={field.value}
              setFieldValue={form.setFieldValue}
            />
          )}
        </Field>
        <Field name={ColorgateConfigurationFields.ProportionalWidth}>
          {({ field, form }) => (
            <NumberFormatField
              name={field.name}
              title={COLORGATE_CONFIGURATION_TITLES.proportionalWidth}
              placeholder="Enter number"
              suffix="cm"
              decimalScale={1}
              value={field.value}
              setFieldValue={form.setFieldValue}
            />
          )}
        </Field>
      </DivInnerFields>
      <Field name={ColorgateConfigurationFields.Rotation}>
        {({ field, form }) => (
          <DropdownField
            name={field.name}
            options={options[ColorgateConfigurationFields.Rotation]}
            title={COLORGATE_CONFIGURATION_TITLES.rotation}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <Field name={ColorgateConfigurationFields.OffsetLeft}>
        {({ field, form }) => (
          <NumberFormatField
            name={field.name}
            title={COLORGATE_CONFIGURATION_TITLES.offsetLeft}
            placeholder="Enter number"
            suffix="cm"
            decimalScale={1}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <Field name={ColorgateConfigurationFields.OffsetTop}>
        {({ field, form }) => (
          <NumberFormatField
            name={field.name}
            title={COLORGATE_CONFIGURATION_TITLES.offsetTop}
            placeholder="Enter number"
            suffix="cm"
            decimalScale={1}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
    </>
  );
};

export default memo(SizeRotationPositionBlock);
